/**
 * @file Alerts for adapter refunds that are still processing or not yet confirmed
 */
import { ALERT_ICON, THINKING_FACE_ICON } from '@@/bits/confirmation_dialog'
import { __ } from '@@/bits/intl'
import { useGlobalAlertDialogStore } from '@@/pinia/global_alert_dialog'

const refundStatusNotices = {
  pending: () => ({
    ...THINKING_FACE_ICON,
    title: __('Refund processing'),
    body: __('Your refund has been requested and is still processing. It can take a few days to appear.'),
  }),
  currencySwitchPending: () => ({
    ...THINKING_FACE_ICON,
    title: __('Currency change processing'),
    body: __('Your currency change is processing. This can take a few days.'),
  }),
  unknown: () => ({
    ...ALERT_ICON,
    title: __('Refund not confirmed yet'),
    body: __('We’re still confirming your refund with the payment provider.'),
  }),
}

function openRefundStatusNotice(
  refundStatus: keyof typeof refundStatusNotices,
  afterCloseActions: Array<() => void>,
): void {
  useGlobalAlertDialogStore().openAlertDialog({
    ...refundStatusNotices[refundStatus](),
    closeButtonText: __('Okay'),
    afterCloseActions,
  })
}

export { openRefundStatusNotice }
